import { render } from "./BusinessAccountOnboardingFormAdditional.vue?vue&type=template&id=638208f2"
import script from "./BusinessAccountOnboardingFormAdditional.vue?vue&type=script&lang=js"
export * from "./BusinessAccountOnboardingFormAdditional.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__